import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { TradeService } from '../../services/tradeService';
import * as BullCache from "../../util/BullCache";
import { customStyles, the } from './customStyles';

const MasterDropdown = ({ adminId, selectedAdmin, setSelectedOption, setSelectedMaster, setSelectedBrokerId, menuPlacement }) => {
  const [masters, setMasters] = useState([]);
  const [selectedOption, setSelectedOptionInternal] = useState(null);

  var user = BullCache.getFromCache("user");

  useEffect(() => {
    const fetchMasterData = async () => {
      setSelectedOptionInternal(null);
      setSelectedOption(null);
      
      let adminId = user?.adminId; 

     if (selectedAdmin) {
        adminId =  selectedAdmin.value;
      }

      try {
        const res = await TradeService.getMaster({ adminId });
        if (res.code === 1 && res.data.masterList.length > 0) {
          setMasters(res.data.masterList);
        }
        else{
          setMasters([]);
        }
      } catch (error) {
        console.error('Error fetching master data:', error);
      }
    };

    if (adminId) {
      fetchMasterData();
    }
  }, [adminId, selectedAdmin]);

  const masterOptions = masters.map((item) => ({
    value: item.adminId,
    label: `${item.firstName} (${item.userName})`,
  }));

  const handleSelectChange = (selected) => {
    setSelectedOptionInternal(selected);
    setSelectedOption(selected); 
    setSelectedMaster(selected); 
    setSelectedBrokerId(null);
  };

  return (
    <div>
      <Select
        menuPlacement={menuPlacement}
        options={masterOptions}
        value={selectedOption}
        onChange={handleSelectChange}
        placeholder="Select"
        isSearchable
        className="text-black fss-01 small-select"
        theme={the} styles={customStyles}
        isClearable
      />
    </div>
  );
};

export default MasterDropdown;
